import { render } from "./GeneralForm.vue?vue&type=template&id=46f487dd"
import script from "./GeneralForm.vue?vue&type=script&lang=js"
export * from "./GeneralForm.vue?vue&type=script&lang=js"

import "./GeneralForm.vue?vue&type=style&index=0&id=46f487dd&lang=css"
script.render = render

export default script